RegistrableMixin = require '../../mixins/registrable'

App.SmFileInputComponent = Em.Component.extend RegistrableMixin,
  tagName: 'input'

  attributeBindings: [
    'type',
    'style',
    'multiple'
    'dataId'
  ]

  style: 'display: none;'.htmlSafe()
  type: 'file'
  multiple: false
  dataId: null

  ###
  # Ограничения на тип файла
  ###
  accept: 'all'

  acceptRegExps: (->
    accept = @get('accept')
    return [ /.*/ ] if accept is 'all'

    accept.split(';').map (pattern) ->
      new RegExp(pattern, 'i')
  ).property('accept')

  files: ((key, val) ->
    if arguments.length > 2
      @

    @$().prop('files')
  ).property()

  change: ->
    files = @$().prop('files')
    @send 'filesSelected', files

  openDialog: ->
    @$().trigger('click')

  actions:
    openDialog: ->
      @openDialog()

    filesSelected: (files) ->
      filesArray = []
      filesArray.push(item) for item in files

      filtered = filesArray.filter (file) =>
        @get('acceptRegExps').any (p) => p.test(file.type)

      alert('Выбранный тип файла не поддерживается') if filtered.length == 0 && filesArray.length != 0

      return if filtered.length <= 0

      if @get('multiple')
        @sendAction 'onFileSelected', filtered, @get('dataId')
      else
        @sendAction 'onFileSelected', filtered[0], @get('dataId')
      false
